var _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupeCandlesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_20745_886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 3.50146C25.9556 3.50146 29.8224 4.67444 33.1114 6.87207C36.4004 9.0697 38.9638 12.1933 40.4776 15.8478C41.9913 19.5023 42.3874 23.5237 41.6157 27.4033C40.844 31.2829 38.9392 34.8465 36.1421 37.6436L29.0711 30.5725C30.4696 29.174 31.422 27.3922 31.8079 25.4524C32.1937 23.5126 31.9957 21.5019 31.2388 19.6746C30.4819 17.8474 29.2002 16.2856 27.5557 15.1868C25.9112 14.088 23.9778 13.5015 22 13.5015V3.50146Z",
    fill: "#FF0400"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_20745_886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1421 37.6436C33.9729 39.8128 31.3337 41.454 28.4288 42.4401C25.5238 43.4262 22.431 43.7308 19.3895 43.3304C16.348 42.9299 13.4393 41.8352 10.8886 40.1309C8.33785 38.4265 6.21337 36.1582 4.67949 33.5015L13.3397 28.5015C14.1067 29.8298 15.1689 30.964 16.4443 31.8162C17.7197 32.6683 19.174 33.2157 20.6947 33.4159C22.2155 33.6161 23.7619 33.4638 25.2144 32.9708C26.6669 32.4777 27.9865 31.6571 29.0711 30.5725L36.1421 37.6436Z",
    fill: "#FFA300"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_20745_886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.67949 33.5015C2.47815 29.6886 1.59644 25.256 2.1711 20.8909C2.74577 16.5259 4.7447 12.4725 7.85786 9.35933L14.9289 16.4304C13.3723 17.987 12.3729 20.0137 12.0856 22.1962C11.7982 24.3787 12.2391 26.595 13.3397 28.5015L4.67949 33.5015Z",
    fill: "#FF6300"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_20745_886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.23711 6.51497C10.8321 3.09235 15.5713 1.12881 20.5334 1.00611L20.7806 11.0031C18.2996 11.0644 15.9299 12.0462 14.1325 13.7575L7.23711 6.51497Z",
    fill: "#FF4200"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_20745_886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5279 52.7639L40 59L52.4721 52.7639C55.86 51.07 58 47.6074 58 43.8197V22.5556C58 21.6406 57.3823 20.8469 56.4863 20.6615C53.7294 20.0911 47.4784 19 40 19C32.5216 19 26.2706 20.0911 23.5137 20.6615C22.6177 20.8469 22 21.6406 22 22.5556V43.8197C22 47.6074 24.14 51.07 27.5279 52.7639Z",
    fill: "url(#paint0_linear_20745_886)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5279 52.7639L40 59L52.4721 52.7639C55.86 51.07 58 47.6074 58 43.8197V22.5556C58 21.6406 57.3823 20.8469 56.4863 20.6615C53.7294 20.0911 47.4784 19 40 19C32.5216 19 26.2706 20.0911 23.5137 20.6615C22.6177 20.8469 22 21.6406 22 22.5556V43.8197C22 47.6074 24.14 51.07 27.5279 52.7639Z",
    fill: "url(#paint1_radial_20745_886)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 58.441L27.7515 52.3167C24.533 50.7075 22.5 47.418 22.5 43.8197V22.5556C22.5 21.8665 22.962 21.2862 23.615 21.1511C26.3518 20.5849 32.5669 19.5 40 19.5C47.4331 19.5 53.6482 20.5849 56.385 21.1511C57.038 21.2862 57.5 21.8665 57.5 22.5556V43.8197C57.5 47.418 55.467 50.7075 52.2485 52.3167L40 58.441Z",
    stroke: "url(#paint2_radial_20745_886)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 58.441L27.7515 52.3167C24.533 50.7075 22.5 47.418 22.5 43.8197V22.5556C22.5 21.8665 22.962 21.2862 23.615 21.1511C26.3518 20.5849 32.5669 19.5 40 19.5C47.4331 19.5 53.6482 20.5849 56.385 21.1511C57.038 21.2862 57.5 21.8665 57.5 22.5556V43.8197C57.5 47.418 55.467 50.7075 52.2485 52.3167L40 58.441Z",
    stroke: "url(#paint3_radial_20745_886)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.867 46.214C40.3712 46.7098 39.6987 46.9883 38.9976 46.9883C38.2964 46.9883 37.624 46.7098 37.1282 46.214M31.5528 43.5305H46.4468C47.0858 43.5305 47.4669 42.8184 47.1125 42.2867L45.7062 40.1773V35C45.7062 31.6863 43.0199 29 39.7062 29H38.2934C34.9797 29 32.2935 31.6863 32.2935 35V40.1773L30.8872 42.2867C30.5327 42.8184 30.9139 43.5305 31.5528 43.5305Z",
    stroke: "#88A2B1",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8671 45.214C41.3713 45.7098 40.6988 45.9883 39.9977 45.9883C39.2965 45.9883 38.6241 45.7098 38.1283 45.214",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4469 42.5305H32.5529C31.914 42.5305 31.5328 41.8184 31.8873 41.2867L33.2936 39.1773V34C33.2936 30.6863 35.9798 28 39.2936 28H40.7063C44.02 28 46.7063 30.6863 46.7063 34V39.1773L48.1126 41.2867C48.467 41.8184 48.0859 42.5305 47.4469 42.5305Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_20745_886",
    x: 18,
    y: -0.498535,
    width: 28,
    height: 42.1421,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_886"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_886",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_20745_886",
    x: 0.679688,
    y: 24.5015,
    width: 39.4624,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_886"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_886",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_20745_886",
    x: -2,
    y: 5.35938,
    width: 20.9287,
    height: 32.1421,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_886"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_886",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_20745_886",
    x: 3.2373,
    y: -2.9939,
    width: 21.5435,
    height: 20.7513,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_886"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_886",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_20745_886",
    x: 16,
    y: 13,
    width: 48,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_886"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_886",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20745_886",
    x1: 23.125,
    y1: 20,
    x2: 43.4304,
    y2: 56.0688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_20745_886",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.125 20) scale(33.75 38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_20745_886",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.25 34.5) rotate(31.3633) scale(23.0564 21.9692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_20745_886",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.25 18) rotate(128.22) scale(12.7285 13.1692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupeCandlesLogo);
export default __webpack_public_path__ + "static/media/supeCandlesLogo.a09f3f0eb86deb58acffc420ac7bbda7.svg";
export { ForwardRef as ReactComponent };